import { faCheckSquare } from '@fortawesome/pro-duotone-svg-icons';
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startLoadingUpdateName } from '../../actions/project';
import { updateProjectNameSelector } from '../../selectors';
import { isEllipsisActive } from '../../utils/dom';
import { LoadingSpinnerSmall } from '../loading-spinner';
import { HomeBlock, HomeBlockTitle } from '../styled';
import TextTooltip from '../tooltip';
import { isMobile } from '../../utils';
import { DetailContent, DetailTitle, DetailContainer, EditProjectNameIcon, ErrorMessage, FormContainerProject, Input, SaveProjectNameIcon, SingleDetail, HomeBlockDetails } from './styled';
import { useHistory } from 'react-router-dom';
import { DEMO_ROUTE } from '../../constants/router';
const ProjectDetail = _ref => {
  let {
    detail,
    id
  } = _ref;
  const dispatch = useDispatch();
  const detailContentRef = useRef(null);
  const showDetailContentTooltip = detailContentRef?.current ? isEllipsisActive(detailContentRef.current) : false;
  const {
    updateNameLoading,
    updateNameError,
    selectedProject
  } = useSelector(updateProjectNameSelector);
  const isName = detail.id === 1;
  const [isEdit, setIsEditName] = useState(false);
  const [name, setName] = useState(isName ? detail.content : '');
  const {
    location: {
      pathname
    }
  } = useHistory();
  const isDemoProject = pathname === DEMO_ROUTE;
  const handleClickEdit = () => setIsEditName(!isEdit);
  const handleChangeName = event => setName(event.target.value);
  const handleSave = event => {
    event.preventDefault();
    dispatch(startLoadingUpdateName(selectedProject, name));
  };

  // Hide input after update
  useEffect(() => {
    if (isEdit) handleClickEdit();
  }, [selectedProject]);
  return /*#__PURE__*/React.createElement(SingleDetail, null, /*#__PURE__*/React.createElement(DetailTitle, null, detail.title), isName && isEdit ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FormContainerProject, null, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: name,
    onChange: handleChangeName,
    disabled: updateNameLoading,
    onKeyPress: e => e.key === 'Enter' && name ? handleSave(e) : undefined
  }), /*#__PURE__*/React.createElement(SaveProjectNameIcon, {
    onClick: name ? handleSave : undefined,
    icon: faCheckSquare,
    size: "1x",
    disabled: !name || updateNameLoading
  }), updateNameLoading && !updateNameError && /*#__PURE__*/React.createElement(LoadingSpinnerSmall, {
    size: 15
  })), updateNameError && !updateNameLoading && /*#__PURE__*/React.createElement(ErrorMessage, null, updateNameError.message)) : /*#__PURE__*/React.createElement(Fragment, null, showDetailContentTooltip ? /*#__PURE__*/React.createElement(TextTooltip, {
    element: /*#__PURE__*/React.createElement(DetailContent, {
      ref: detailContentRef
    }, detail.content),
    text: detail.content,
    multiline: false
  }) : /*#__PURE__*/React.createElement(DetailContainer, null, /*#__PURE__*/React.createElement(DetailContent, {
    ref: detailContentRef
  }, detail.content), isName && !isMobile && /*#__PURE__*/React.createElement(EditProjectNameIcon, {
    size: "2x",
    icon: faPenToSquare,
    onClick: isEdit || isDemoProject ? undefined : handleClickEdit,
    disabled: isEdit || isDemoProject
  }))));
};
const detailPropShape = {
  id: PropTypes.number,
  title: PropTypes.string,
  content: PropTypes.string
};
ProjectDetail.propTypes = {
  detail: PropTypes.shape(detailPropShape).isRequired
};
const DetailsView = props => {
  return /*#__PURE__*/React.createElement(HomeBlock, {
    centerOnMobile: true
  }, /*#__PURE__*/React.createElement(HomeBlockTitle, null, "R\xE9f\xE9rences"), /*#__PURE__*/React.createElement(HomeBlockDetails, null, props.details.map((detail, i) => /*#__PURE__*/React.createElement(ProjectDetail, {
    key: detail.title,
    id: `detail-${i}`,
    detail: detail
  }))));
};
DetailsView.propTypes = {
  details: PropTypes.arrayOf(PropTypes.shape(detailPropShape)),
  id: PropTypes.string
};
export default DetailsView;